import { render } from "./PopupMenu.vue?vue&type=template&id=4bcccad8"
import script from "./PopupMenu.vue?vue&type=script&lang=js"
export * from "./PopupMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akhenry/Code/openmct-clean/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__